import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(fetchBaseQuery(), { maxRetries });

export const protocolAPI = createApi({
	reducerPath: "protocolAPI",
	baseQuery,
	keepUnusedDataFor: 0,
	tagTypes: ["tagGetProtocols", "tagGetProtocolsLight"],
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		//* *********************************************************** */
		//* GET PROTOCOLS */
		getProtocols: builder.query({
			query: (body: any) => ({
				url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/?&page=1&limit=99999`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetProtocols"],
		}),
		//* *********************************************************** */
		//* GET PROTOCOLS LIGHT*/
		getProtocolsLight: builder.query({
			query: (body: any) => ({
				url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/light/?&page=${body.page}&limit=${body.limit}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetProtocolsLight"],
		}),
		//* *********************************************************** */
		//* POST PROTOCOL TYPE */
		postProtocol: builder.mutation({
			query: (body: any) => ({
				url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/`,
				method: "post",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetProtocols"],
		}),
		//* *********************************************************** */
		//* PUT PROTOCOL TYPE */
		putProtocol: builder.mutation({
			query: (body: any) => ({
				url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/${body.id}`,
				method: "put",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetProtocols"],
		}),
		//* *********************************************************** */
		//* DELETE PROTOCOL TYPE */
		deleteProtocol: builder.mutation({
			query: (body: any) => ({
				url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/protocols/${body.id}`,
				method: "delete",
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetProtocols"],
		}),
		//* *********************************************************** */
	}),
});

export const {
	useLazyGetProtocolsQuery,
	usePostProtocolMutation,
	usePutProtocolMutation,
	useDeleteProtocolMutation,
	useGetProtocolsLightQuery,
} = protocolAPI;
